import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch, jsonHeaders } from "../api/api";
import logo from "../logo.png";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    setMessage("");
    try {
      const res = await apiFetch("/password-reset/request", {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({ email }),
      });
      setMessage(res?.message || "If the account exists, a reset link has been sent.");
    } catch (e) {
      setMessage("If the account exists, a reset link has been sent.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "80vh", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: 32, marginBottom: 32 }}>
        <img src={logo} alt="Counselor Notes Logo" style={{ width: 400, maxWidth: "90vw" }} />
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "40vh", width: 360 }}>
        <h1 style={{ textAlign: "center" }}>Forgot Password</h1>
        <form onSubmit={onSubmit} style={{ width: "100%", display: "grid", gap: 16, marginTop: 24 }}>
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{ padding: 12, fontSize: 16, borderRadius: 6, border: "1px solid #cbd5e1" }} />
          <button type="submit" disabled={busy || !email} style={{ padding: 12, fontSize: 16, background: "#2563eb", color: "#fff", border: "none", borderRadius: 6, cursor: busy ? "not-allowed" : "pointer" }}>{busy ? "Sending…" : "Send reset link"}</button>
        </form>
        {message && <div style={{ color: "#065f46", marginTop: 12 }}>{message}</div>}
        {error && <div style={{ color: "#b91c1c", marginTop: 12 }}>{error}</div>}
        <button onClick={() => navigate("/login")} style={{ marginTop: 16, background: "none", border: "none", color: "#2563eb", cursor: "pointer" }}>Back to Login</button>
      </div>
    </div>
  );
}
